export type AiLayoutRoofResolveInput = {
    layoutKey: string;
    categoryLabel?: string;
    roofCombinationsFromAi: Array<{ name: string; roofFaceIds?: string[] }>;
    layoutCandidatesByCategory: Record<string, Array<{ key: string; roofFaceIds?: string[] }>>;
    bestRoofsForLayout: { roofFaceIds?: string[] };
    defaultMaxfillRoofIds?: string[];
};

/** Resolve roof face IDs for applying an AI catalog layout in the 3D viewer. */
export function resolveAiLayoutRoofFaceIds(input: AiLayoutRoofResolveInput): string[] {
    const {
        layoutKey,
        categoryLabel,
        roofCombinationsFromAi,
        layoutCandidatesByCategory,
        bestRoofsForLayout,
        defaultMaxfillRoofIds,
    } = input;

    if (layoutKey === 'default') {
        return Array.isArray(defaultMaxfillRoofIds) ? defaultMaxfillRoofIds.filter(Boolean) : [];
    }

    const fromComboName = (name: string): string[] => {
        const combo = roofCombinationsFromAi.find((c) => c.name === name);
        return Array.isArray(combo?.roofFaceIds) && combo.roofFaceIds.length > 0
            ? combo.roofFaceIds.filter(Boolean)
            : [];
    };

    let ids = fromComboName(layoutKey);
    if (!ids.length && categoryLabel) {
        ids = fromComboName(categoryLabel);
    }
    if (ids.length) return ids;

    if (categoryLabel) {
        const candidates = layoutCandidatesByCategory[categoryLabel] || [];
        const byKey = candidates.find((c) => c.key === layoutKey);
        if (byKey?.roofFaceIds?.length) return byKey.roofFaceIds.filter(Boolean);
        const top = candidates[0];
        if (top?.roofFaceIds?.length) return top.roofFaceIds.filter(Boolean);
    }

    for (const candidates of Object.values(layoutCandidatesByCategory)) {
        const match = candidates.find((c) => c.key === layoutKey);
        if (match?.roofFaceIds?.length) return match.roofFaceIds.filter(Boolean);
    }

    const fallback = bestRoofsForLayout.roofFaceIds ?? [];
    return fallback.length > 0 ? fallback.filter(Boolean) : [];
}
